import { render, staticRenderFns } from "./Tabulator.vue?vue&type=template&id=061a363a&scoped=true&"
import script from "./Tabulator.vue?vue&type=script&lang=js&"
export * from "./Tabulator.vue?vue&type=script&lang=js&"
import style0 from "./Tabulator.vue?vue&type=style&index=0&id=061a363a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061a363a",
  null
  
)

export default component.exports